<div class="card" [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
  [style.background-color]="clozeTestStyleModel().exerciseBackground" [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '8px',
        width: mobileMode() ? '' : '720px',
      }">
  <div class="card-body pb-1" [ngClass]="{ 'card-mobile': mobileMode() }"
    [style.font-family]="clozeTestStyleModel().font"
    [style.font-size]="mobileMode() ? '16px' : clozeTestStyleModel().fontSize">
    @if (mobileMode()) {
    <div class="d-flex align-items-center justify-content-between card-title-row">
      <h4 class="card-title" [innerHTML]="title()"></h4>
      <cloze-test-exercise-indicator [totalExercise]="totalExercise()" [currentExerciseNumber]="currentExcerciseNumber()"
        [clozeTestStyleModel]="clozeTestStyleModel()">
      </cloze-test-exercise-indicator>
    </div>
    } @else {
    <div class="card-title-row">
      <h4 class="card-title" [innerHTML]="title()"></h4>
    </div>
    }
    <div [style.line-height]="lineHeight">
      @for (input of inputs; track input; let i = $index) {
      <cloze-test-exercise-input [mobileMode]="mobileMode()" [nr]="$any(input.id)" [text]="input.text"
        [isLast]="i === inputs.length - 1" [lastWord]="input.lastWord" [answer]="input.answer"
        [clozeTestStyleModel]="clozeTestStyleModel()" (answerChange)="input.answer = $event">
      </cloze-test-exercise-input>
      }
    </div>
    <div>
      @if (inputs && inputs.length > 0) {
      @if (mobileMode()) {
      <!-- Mobile: checkbox + button on same row -->
      <div class="d-flex justify-content-between align-items-center" style="margin-top: 16px">
        <div class="d-flex align-items-center" style="cursor: pointer" (click)="readyCheckbox = !readyCheckbox">
          <cloze-test-custom-checkbox [checked]="readyCheckbox"
            [color]="clozeTestStyleModel().specialCharacterListColor"
            (checkedChange)="readyCheckbox = $event"></cloze-test-custom-checkbox>
          <span style="padding-left: 6px">{{ lang().toLowerCase() === 'de' ? 'Fertig' : 'Text completed' }}</span>
        </div>
        <div style="height:36px">
          @if (!isLastExercise()) {
          <button class="btn" style="font-size: smaller" (click)="onNextExercise()" [hidden]="!readyCheckbox"
            [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor()">
            {{ lang().toLowerCase() === 'de' ? 'Weiter' : 'Next' }}
            <i class="fas fa-arrow-right ms-2"></i>
          </button>
          } @else {
          <button class="btn" style="font-size: smaller" (click)="onTestEnd()" [hidden]="!readyCheckbox"
            [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor()">
            {{ lang().toLowerCase() === 'de' ? 'Test beenden' : 'End test' }}
          </button>
          }
        </div>
      </div>
      } @else {
      <!-- Desktop: checkbox alone, then "Text X von Y" + button on same row -->
      <div class="d-flex align-items-center" style="cursor: pointer; margin-top: 24px"
        (click)="readyCheckbox = !readyCheckbox">
        <cloze-test-custom-checkbox [checked]="readyCheckbox" [color]="clozeTestStyleModel().specialCharacterListColor"
          (checkedChange)="readyCheckbox = $event"></cloze-test-custom-checkbox>
        <span style="padding-left: 6px; margin-bottom: 0">
          {{ lang().toLowerCase() === 'de' ? 'Fertig' : 'Text completed' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center exercise-number" style="margin-top: 24px">
        <p class="mb-0">
          {{
          lastExerciseNumber() !== undefined && lastExerciseNumber() !== null
          ? ('Text ' + currentExcerciseNumber() + (lang().toLowerCase() === 'de' ? ' von ' : ' of ') + lastExerciseNumber())
          : ('Text ' + currentExcerciseNumber())
          }}
        </p>
        <div>
          @if (!isLastExercise()) {
          <button class="btn" style="font-size: smaller" (click)="onNextExercise()" [hidden]="!readyCheckbox"
            [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor()">
            {{ lang().toLowerCase() === 'de' ? 'Weiter' : 'Next' }}
            <i class="fas fa-arrow-right ms-2"></i>
          </button>
          } @else {
          <button class="btn" style="font-size: smaller" (click)="onTestEnd()" [hidden]="!readyCheckbox"
            [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor()">
            {{ lang().toLowerCase() === 'de' ? 'Test beenden' : 'End test' }}
          </button>
          @if (timeLeft <= limitWhenToShowTime) {
          {{ lang().toLowerCase() === 'de' ? 'Verbleibende Sekunden:' : 'Time remaining:' }}
          {{ timeLeft }}
          }
          }
        </div>
      </div>
      }
      }
    </div>
  </div>
</div>

<!-- special character for non german keyboard; not needed for the English c-test -->
  @if (!mobileMode() && lang().toLowerCase() !== 'en') {
  <div class="d-flex justify-content-center" style="margin-top: 8px">
    <div class="alert text-center" style="width: 720px; line-height: 30px; padding: 0 14px"
      [style.background-color]="clozeTestStyleModel().specialCharacterListColor"
      [style.border]="'1px solid ' + clozeTestStyleModel().frameColor" [style.font-family]="clozeTestStyleModel().font"
      role="alert">
      <span class="special-char-info" [style.color]="clozeTestStyleModel().specialCharacterTextColor">{{
        lang().toLowerCase() === 'de'
        ? 'Hier klicken, wenn du Umlaute oder "ß" brauchst: '
        : 'Click here, if you need special characters '
        }}</span>
      <span [tabindex]="0" class="badge badge-secondary" (keyup.enter)="assignCharacter('ä', $event)"
        (click)="assignCharacter('ä', $event)" [style.font-size]="'16px'" style="margin-right: 5px; cursor: pointer"
        [style.border]="'1px solid ' + clozeTestStyleModel().specialCharacterTextColor" [style.border-radius]="'4px'"
        [style.background-color]="clozeTestStyleModel().specialCharacterListColor">ä</span>
      <span [tabindex]="0" class="badge badge-secondary" (keyup.enter)="assignCharacter('ö', $event)"
        (click)="assignCharacter('ö', $event)" [style.font-size]="'16px'" style="margin-right: 5px; cursor: pointer"
        [style.border]="'1px solid ' + clozeTestStyleModel().specialCharacterTextColor" [style.border-radius]="'4px'"
        [style.background-color]="clozeTestStyleModel().specialCharacterListColor">ö</span>
      <span [tabindex]="0" class="badge badge-secondary" (keyup.enter)="assignCharacter('ü', $event)"
        (click)="assignCharacter('ü', $event)" [style.font-size]="'16px'" style="margin-right: 5px; cursor: pointer"
        [style.border]="'1px solid ' + clozeTestStyleModel().specialCharacterTextColor" [style.border-radius]="'4px'"
        [style.background-color]="clozeTestStyleModel().specialCharacterListColor">ü</span>
      <span [tabindex]="0" class="badge badge-secondary" (keyup.enter)="assignCharacter('ß', $event)"
        (click)="assignCharacter('ß', $event)" [style.font-size]="'16px'" style="margin-right: 5px; cursor: pointer"
        [style.border]="'1px solid ' + clozeTestStyleModel().specialCharacterTextColor" [style.border-radius]="'4px'"
        [style.background-color]="clozeTestStyleModel().specialCharacterListColor">ß</span>
    </div>
  </div>
  }
